var React = require('react');

function CrossCircleIcon (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"currentColor","cx":"12","cy":"12","r":"10","key":0}),React.createElement("path",{"fill":"#FFFFFF","d":"m13.414 12 2.293-2.293a1 1 0 0 0 -1.414-1.414l-2.293 2.293-2.293-2.293a1 1 0 0 0 -1.414 1.414l2.293 2.293-2.293 2.293a1 1 0 1 0 1.414 1.414l2.293-2.293 2.293 2.293a1 1 0 0 0 1.414-1.414z","key":1})]);
}

CrossCircleIcon.defaultProps = {"data-dmid":"dm-cross-circle","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color8"};

module.exports = CrossCircleIcon;

CrossCircleIcon.default = CrossCircleIcon;
